<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-forgot">
      <p class="title title-double-line">退会<span class="mini">-&nbsp;塔経市帝電子異界接続許可証返却届&nbsp;-</span></p>

      <div class="description">
        <p>異界舞踏会・アキバトリカルの退会手続きを行います。</p>
        <p>退会を実行すると、現在所有しているアイテムやポイント、塔経通貨など全てのアイテムやポイントは消失し、元に戻すことはできません。</p>
        <p>また、これまでご投稿いただいたコンテンツや、キャンペーンへの応募や応募資格等も全て消失し、復元することはできません。</p>
        <p>上記を御確認、ご了承の上、退会をご希望の方は以下のフォームにパスワードをご入力ください。</p>
        <p>パスワードを入力後、退会ボタンを押すと即退会処理が実行されます。確認画面等は表示されませんのでご注意ください。</p>
      </div>

      <PaFrontForm
        :action="'/'"
        :formSet="formSet"
        :submitText="'退会'"
        :submitLoading="submitLoading"
        
        @handleSubmit="handleSubmit"
      />
    </div>
  </section>
</template>

<script>
import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FormValidationControlMixin,
    FrontPageMixins
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      submitLoading : false,
      
      formSet       : {
        password       : {
          label           : 'パスワード',
          description     : ' \
          <p>ログイン時に使用するパスワードをご入力ください。</p> \
          ',
          validationRules : ['notEmpty', 'max', 'password'],
          inputType       : 'password',
        }
      }
    };
  },

  methods : {
    async handleSubmit(){
      this.submitLoading = true;
      
      if( this.checkFormPreValidation() ){
        this.disabledFields();

        const results = await this.$store.dispatch({
          type      : 'requests/registration/leave',
          password  : this.formSet['password']['value'],
        });

        const validationResult = await this.RESTResultResultValidationGuard(results, [422]);

        this.submitLoading = false;
        this.unDisabledFields();

        if(validationResult === true){
          await this.$store.dispatch('systemLeaveLogout');
          
          Object.values(this.$apollo.provider.clients)
            .forEach(client => client.cache.reset());
          
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;退会手続きが完了致しました。異界舞踏会・アキバトリカルのご利用及び塔経市帝へのご滞在誠にありがとうございました。',
            status      : 'primary',
            hasControl  : true,
            autoClose   : 20000
          }, {root:true});

          await this.handleRequestValidationError('authentication');
        }else{
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;御入力いただきましたパスワードが間違っています。正確なパスワードを御入力くださいませ。',
            status      : 'error',
            hasControl  : true,
            autoClose   : 10000
          }, {root:true});
        }

      }else{
        this.submitLoading = false;
        this.unDisabledFields();

        this.flashMessageToScroll({
          status    : 'error',
          text      : '&nbsp;入力項目にエラーが存在します。今一度ご確認ください。',
          autoClose : 1800,
          cancelBtn : false,
        });
      }
    }
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : true
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

.pa-section{
  &-registration{
    .pa-forgot{
      
    }
  }
}
</style>